import { FC } from 'react';
import { getSymbolId } from './SvgIcon.helpers';

type Props = {
  name: string;
  viewBox: string;
  children: React.ReactNode;
};

export const SvgPreloadedIcon: FC<Props> = ({ name, viewBox, children }) => {
  return (
    <symbol id={getSymbolId(name)} viewBox={viewBox}>
      {children}
    </symbol>
  );
};
